module.exports = __webpack_public_path__ + "static/media/carouselThree.d228e5a6.png";